import { Printer, SearchX } from 'lucide-react';

interface EfaxEmptyStateProps {
  hasSearched: boolean;
}

export const EfaxEmptyState = ({ hasSearched }: EfaxEmptyStateProps) => (
  <div className="flex items-center justify-center py-16">
    <div className="max-w-sm text-center">
      <div className="bg-muted mx-auto mb-4 flex size-12 items-center justify-center rounded-full border">
        {hasSearched ? (
          <SearchX className="size-5" />
        ) : (
          <Printer className="size-5" />
        )}
      </div>
      <h2 className="text-lg font-semibold">
        {hasSearched ? 'No eFax Documents Found' : 'Search for an eFax'}
      </h2>
      <p className="text-muted-foreground mt-1 text-sm">
        {hasSearched
          ? 'Adjust the search criteria and try again.'
          : 'Use the search controls above to populate the eFax queue.'}
      </p>
    </div>
  </div>
);
